// This is a copy of measureSystemUtils from the backend repo
// The conversion formulas are taken from excel sheet attached to.
// https://hydrosat.atlassian.net/jira/software/c/projects/IW/boards/35?selectedIssue=IW-292
/**
 * A base function for conversion
 * @param val
 * @param mul
 * @param offset
 */

import {round} from "lodash";

// Base function
const convert = (val: number, mul = 1, offset = 0) => {
    return round(val * mul + offset, 3);
};

/**
 * Celsius => Fahrenheit | C to °F
 * @param v - hectares
 */
export const cToF = (v: number) => {
    return convert(v, 1.8, 32);
};

/**
 * Kelvin => Fahrenheit | K to °F
 * @param v - value
 */
export const kToF = (v: number): number => {
    return convert(v, 1.8, -459.67);
};

/**
 * Convert ha => acres
 * @param v - value
 */
export const haToAcre = (v: number) => {
    return convert(v, 2.47105);
};

/**
 * Millimeters to Inches. Also used to convert all functions where denominator is the same, like
 * mm/d => inch/d,
 * @param v - mm
 */
export const mmToInch = (v: number) => {
    return convert(v, 0.0393701);
};

/**
 * cm/d => inch/d,
 * @param v - cm
 */
export const cmToInch = (v: number) => {
    return convert(v, 0.393701);
};

/**
 * Convert kg/ha => lb/acres
 * @param v
 */
export const kgByhaToLbByAcre = (v: number) => {
    return convert(v, 0.892179);
};

/**
 * kg / ha per day => Pounds/Acres per day
 * @param v - value
 */
export const kgHaDToLbAcreD = (v: number) => {
    return kgByhaToLbByAcre(v);
};

/**
 * kg / m^3  => Pounds / feet^3
 * @param v
 */
export const kgCubeMToLbCubeFt = (v: number) => {
    return convert(v, 0.062428);
};

/**
 * s / m  => s / inch
 * @param v
 */
export const sbyMTosByInch = (v: number) => {
    return convert(v, 0.0254407611875747);
};

/**
 * W/m^2  => W/feet^2
 * @param v
 */
export const byMeterSquareToByFeetSquare = (v: number) => {
    return convert(v, 0.0929031299064465);
};

/**
 * Meter per Second to Mile Per hour. Used For wind speed
 * @param v
 */
export const meterPerSecondToMilePerHour = (v: number) => {
    return convert(v, 2.23694);
};

/**
 * mm3/mm3 to in/ft
 * @param v
 */
export const cmCubeToInchByFoot = (v: number) => {
    return convert(v, 12);
};

/**
 * hPa => PSI
 * @param v - value
 */
export const hPaToPsi = (v: number) => {
    return convert(v, 0.0145037738);
};
